import { Breadcrumb } from 'components/Breadcrumb/Breadcrumb';
import { observer } from 'mobx-react-lite';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCartContext } from 'screens/AccessExpressV3/CartProvider';

const ResumeOrderBreadcrumbs = observer(() => {
  const navigate = useNavigate();
  const cart = useCartContext();

  const breadcrumbs = useMemo(
    () => [
      {
        icon: 'home',
        label: 'Order services',
        onClick: () => navigate('/access-express/v3/draft'),
      },
      ...(cart.resumeOrder?.orderName
        ? [
            {
              label: `${cart.resumeOrder?.orderName}`,
            },
          ]
        : []),
    ],
    [cart.resumeOrder, navigate],
  );
  if (!cart.resumeOrder?.id) return null;

  return <Breadcrumb breadcrumbs={breadcrumbs} />;
});

export default ResumeOrderBreadcrumbs;
